import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private showBannerEvent = new BehaviorSubject<boolean>(false);
  private disableHelpButtonEvent = new BehaviorSubject<boolean>(false);
  private updateProductImageURL = new BehaviorSubject<string>('');
  private showEntrySpinner = new BehaviorSubject<string>('');
  private hideEntrySpinner = new BehaviorSubject<string>('');
  private showIndexSpinner = new BehaviorSubject<void>(undefined);
  private hideIndexSpinner = new BehaviorSubject<void>(undefined);

  getShowBannerEvent() {  
    return this.showBannerEvent.asObservable();
  }

  emitShowBannerEvent(multipleTerms: boolean): void {
    this.showBannerEvent.next(multipleTerms);
  }
  
  getDisableHelpButtonEvent() {  
    return this.disableHelpButtonEvent.asObservable();
  }

  emitDisableHelpButtonEvent(disable: boolean): void {
    this.disableHelpButtonEvent.next(disable);
  }

  getUpdateProductImageURL() {  
    return this.updateProductImageURL.asObservable();
  }

  emitUpdateProductImageURL(url: string): void {
    this.updateProductImageURL.next(url);
  }

  getShowEntrySpinner() {  
    return this.showEntrySpinner.asObservable();
  }

  emitShowEntrySpinner(url: string): void {
    this.showEntrySpinner.next(url);
  }

  getHideEntrySpinner() {  
    return this.hideEntrySpinner.asObservable();
  }

  emitHideEntrySpinner(url: string): void {
    this.hideEntrySpinner.next(url);
  }

  getShowIndexSpinner() {  
    return this.showIndexSpinner.asObservable();
  }

  emitShowIndexSpinner(): void {
    this.showIndexSpinner.next();
  }

  getHideIndexSpinner() {  
    return this.hideIndexSpinner.asObservable();
  }

  emitHideIndexSpinner(): void {
    this.hideIndexSpinner.next();
  }

}
